import React, { useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';

const setConsentInLocalStorage = (consent) => {
  localStorage.setItem('cookieConsent', consent);
};

const GDPRPopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    setShowPopup(consent !== 'true');
  }, []);

  const handleAccept = () => {
    setConsentInLocalStorage(true);
    setShowPopup(false);
  };

  return (
    showPopup && (
      <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, p: 2, background: 'rgba(0, 0, 0, 0.8)', color: 'white', textAlign: 'center', zIndex: 99 }}>
        <Typography variant="body1" sx={{ mb: 0 }}>We use cookies to improve your experience on our site. By using our site you consent cookies.</Typography>
        <Button
          sx={{ mr: 2, mt: 2, color: 'white', borderColor: 'white', border: '1px solid white' }}
          onClick={handleAccept}>
          Accept
        </Button>
      </Box>
    )
  );
};

export default GDPRPopup;
